import { solution_listing_path } from "@routes/routes";
import { formatPathForRouter } from "@routes/utils";
import { SolutionListingType } from "@tsTypes/__generated__/enums/solution_listing_type";
import { DiscoverSolutionListing } from "@tsTypes/discover_feed";

export const getSolutionListingNavigationState = (slug: string, fromLabel: string) => ({
  pathname: formatPathForRouter(solution_listing_path(slug)),
  state: { fromHref: window.location.pathname, fromLabel },
});

export enum TagType {
  SOLUTION = "solution",
  INSTITUTION = "institution",
  LISTING_TYPE = "listing_type",
  GENERIC = "generic",
}

export interface SolutionTag {
  label: string;
  type: TagType;
}

const LISTING_TYPE_LABELS: Record<SolutionListingType, string> = {
  [SolutionListingType.TECHNOLOGY_PRODUCT]: "Tech / Product",
  [SolutionListingType.SERVICE_OTHER]: "Service / Other",
};

export const buildSolutionTags = (listing: DiscoverSolutionListing): SolutionTag[] => {
  const tags: SolutionTag[] = [];

  if (listing.listing_type) {
    tags.push({
      label: LISTING_TYPE_LABELS[listing.listing_type],
      type: TagType.LISTING_TYPE,
    });
  }

  if (listing.technology_readiness_label) {
    tags.push({
      label: listing.technology_readiness_label,
      type: TagType.SOLUTION,
    });
  }

  if (listing.organization?.type) {
    tags.push({
      label: listing.organization.type,
      type: TagType.INSTITUTION,
    });
  }

  return tags;
};
